<template>
  <div>
    <b-modal
      ref="modal"
      title="Configurações de Crediário"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      size="lg"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-md-12">
            <h5 class="text-primary">
              <i class="fas fa-percentage" /> Configurações de Juros
            </h5>
          </div>
        </div>

        <br />
        <div class="row">
          <div class="form-group">
            <b-form-group>
              <div class="col-12">
                <b-form-radio-group
                  v-model="form.bill_interest_calculation_method.value"
                  :options="form.bill_interest_calculation_method.options"
                ></b-form-radio-group>
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-4">
              <number-input
                :alias="'Taxa percentual de juros ao mês'"
                v-model="form.tax_interest.value"
                :currencySymbol="' %'"
              />
            </div>
            <div class="col-md-4">
              <number-input
                :alias="'Percentual máximo de desconto'"
                v-model="form.bill_max_discount_receive.value"
                :currencySymbol="' %'"
              />
            </div>
          </div>
        </div>
      </div>

      <error-handler :error="error" />

      <div slot="modal-footer">
        <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Form from "../../../mixins/Form";

export default {
  data: function() {
    return {
      form: new Form({
        id: {},

        bill_interest_calculation_method: {
          options: [
            { text: "Ultilizar cálculo de juros simples", value: "s" },
            { text: "Ultilizar cálculo de juros compostos", value: "c" }
          ]
        },

        tax_interest: {},

        bill_max_discount_receive: {}
      }),

      error: null
    };
  },

  computed: {},

  methods: {
    open() {
      this.error = null;

      this.form.setValues(this.$store.state.company);

      this.$refs.modal.show();
    },

    store() {
      this.$store.commit("showLoading");
      axios
        .post("api/company/updatebillsettings", this.form.getValues())
        .then(response => {
          this.$store.commit("updateCompany", { company: response.data });

          this.$refs.modal.hide();

          this.$store.commit("hideLoading");
        })
        .catch(error => {
          this.error = error;

          this.$store.commit("hideLoading");
        });
    }
  }
};
</script>

<style>
</style>
